import { Button } from '@deere/ux.uxframe-react'
import { saveAs } from 'file-saver'
import React from 'react'
import * as XLSX from 'xlsx'

export const Template = ({csvData, fileName}) => {

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const exportToCSV = (csvData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], {type: fileType});
        saveAs(data, fileName + fileExtension);
    }

    const handleClick = event => {
        exportToCSV(csvData,fileName)
    }

    return (
        <Button onClick={handleClick}>Download</Button>
    )
}